/* Trigger Automotive – búsqueda por número de bastidor (VIN), por matrícula y "Mi vehículo".
 * Decodifica en el navegador con tablas propias (assets/ta-vin-data.js), con la base propia de bastidores
 * construida con los microdatos públicos de la DGT (assets/ta-vin-db.js + ta-vindb-*.json: marca, modelo,
 * motorizaciones y años por los 8 primeros caracteres del VIN) y, para vehículos de EE. UU., con la API pública vPIC de la NHTSA.
 * La matrícula se consulta en el servicio configurado en el tema (settings.ta_plate_endpoint); sin él, no se usa.
 * Los textos llegan traducidos en window.TA_I18N (snippets/ta-i18n.liquid). */
(function () {
  'use strict';

  var DATA = window.TA_VIN_DATA || { wmi: {}, year: {}, rules: [] };
  var DB = window.TA_VIN_DB || null;
  var STORE_KEY = 'ta_vehicle';
  var YEAR_CHARS = 'ABCDEFGHJKLMNPRSTVWXY123456789';
  var settings = window.TA_VIN_SETTINGS || {};

  /* ---------- utilidades ---------- */
  function T(key, vars) {
    var s = (window.TA_I18N || {})[key];
    if (s == null) s = key;
    return vars ? s.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; }) : s;
  }
  function fuelName(code) {
    var s = T('fuel_' + code);
    return s === 'fuel_' + code ? '' : s;
  }
  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();
  }
  function flat(s) { return norm(s).replace(/[^a-z0-9]/g, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function storage(action, value) {
    try {
      if (action === 'get') return JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (action === 'set') localStorage.setItem(STORE_KEY, JSON.stringify(value));
      if (action === 'del') localStorage.removeItem(STORE_KEY);
    } catch (e) {
      return null;
    }
    return null;
  }

  /* ---------- decodificación ---------- */
  function cleanVin(raw) {
    var v = String(raw || '').toUpperCase().replace(/[\s\-_.]/g, '');
    var fixed = v.replace(/O/g, '0').replace(/[IQ]/g, function (c) { return c === 'I' ? '1' : '0'; });
    return { vin: fixed, corrected: fixed !== v, original: v };
  }

  function decodeYear(c, range) {
    var i = YEAR_CHARS.indexOf(c);
    if (i < 0) return null;
    var max = new Date().getFullYear() + 1;
    var cands = [1980 + i, 2010 + i].filter(function (y) { return y <= max; });
    if (range) {
      var inRange = cands.filter(function (y) { return y >= range[0] - 1 && y <= (range[1] || max) + 1; });
      if (inRange.length) return inRange[inRange.length - 1];
      return null;
    }
    return cands.length ? cands[cands.length - 1] : null;
  }

  function decode(raw) {
    var c = cleanVin(raw);
    var vin = c.vin;
    var out = { vin: vin, corrected: c.corrected, valid: false, errors: [], make: null, country: null, models: [], chassis: null, year: null };
    if (vin.length !== 17) {
      out.errors.push(T('err_length', { count: vin.length }));
      return out;
    }
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
      out.errors.push(T('err_chars'));
      return out;
    }
    out.valid = true;
    var w = DATA.wmi[vin.slice(0, 3)] || DATA.wmi[vin.slice(0, 2)];
    if (w) {
      out.make = w[0];
      out.country = w[1] || null;
    }
    // Reglas de modelo/chasis
    var matches = (DATA.rules || []).filter(function (r) {
      // r = [marca, prefijosWMI, inicio, fin, código, modelos, chasis, desde, hasta]
      if (out.make && r[0] !== out.make) return false;
      if (r[1] && r[1].length && !r[1].some(function (p) { return vin.indexOf(p) === 0; })) return false;
      return vin.slice(r[2] - 1, r[3]) === r[4];
    });
    if (!out.make && matches.length) out.make = matches[0][0];
    // Año (solo si la marca lo codifica en la posición 10). Prioridad: lo medido con los datos de la DGT
    var dbYear = DB && DB.year ? DB.year[vin.slice(0, 3)] : undefined;
    var yr = dbYear !== undefined ? dbYear === 1 : DATA.year[vin.slice(0, 3)];
    if (yr === undefined) yr = DATA.year[out.make];
    if (yr) {
      var range = matches.length ? [Math.min.apply(null, matches.map(function (m) { return m[7] || 1980; })), Math.max.apply(null, matches.map(function (m) { return m[8] || 0; })) || null] : null;
      out.year = decodeYear(vin.charAt(9), range);
    }
    if (out.year && matches.length > 1) {
      var byYear = matches.filter(function (m) { return out.year >= (m[7] || 0) - 1 && out.year <= (m[8] || 9999) + 1; });
      if (byYear.length) matches = byYear;
    }
    var models = [];
    matches.forEach(function (m) { (m[5] || []).forEach(function (x) { if (models.indexOf(x) < 0) models.push(x); }); });
    out.models = models;
    out.chassis = matches.map(function (m) { return m[6]; }).filter(Boolean).filter(function (x, i, a) { return a.indexOf(x) === i; }).join(' / ') || null;
    // Años de la generación identificada (sirven para acotar los años de las motorizaciones)
    out.genYears = matches.length ? [Math.min.apply(null, matches.map(function (m) { return m[7] || 9999; })), Math.max.apply(null, matches.map(function (m) { return m[8] || 0; }))] : null;
    out.serial = vin.slice(11);
    return out;
  }

  /* vPIC (NHTSA): datos extra para VIN de mercado norteamericano y fabricante/año para otros */
  var MB_CLASS = { 'M-Class': 'ML', 'GL-Class': 'GL / GLS', 'GLS-Class': 'GL / GLS', 'GLE-Class': 'GLE', 'GLC-Class': 'GLC', 'GLK-Class': 'GLK', 'R-Class': 'Clase R', 'E-Class': 'Clase E', 'S-Class': 'Clase S', 'C-Class': 'Clase C', 'CLS-Class': 'CLS', 'CL-Class': 'CL', 'G-Class': 'Clase G', 'SL-Class': 'SL', 'SLK-Class': 'SLK', 'A-Class': 'Clase A', 'B-Class': 'Clase B', 'CLA-Class': 'CLA', 'GLA-Class': 'GLA', 'GLB-Class': 'GLB', 'Sprinter': 'Sprinter' };
  function vpicModelToStore(make, model) {
    if (!model) return null;
    if (make === 'Mercedes-Benz' && MB_CLASS[model]) return MB_CLASS[model];
    if (make === 'BMW') {
      var s = model.match(/([1-8])[\s-]?Series/i);
      if (s) return 'Serie ' + s[1];
      var x = model.match(/^(X[1-7]|Z4)/i);
      if (x) return x[1].toUpperCase();
    }
    return model;
  }
  function fetchVpic(vin) {
    if (!window.fetch || settings.vpic === false) return Promise.resolve(null);
    var ctrl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);
    return fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/' + vin + '?format=json', ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        clearTimeout(t);
        var row = j && j.Results && j.Results[0];
        if (!row) return null;
        var pick = function (k) { var v = row[k]; return v && v !== 'Not Applicable' && v !== '0' ? String(v).trim() : ''; };
        return {
          make: pick('Make'), model: pick('Model'), year: pick('ModelYear'), trim: pick('Trim'), series: pick('Series'),
          body: pick('BodyClass'), litres: pick('DisplacementL'), cylinders: pick('EngineCylinders'), engine: pick('EngineModel'),
          fuel: pick('FuelTypePrimary'), drive: pick('DriveType'), transmission: pick('TransmissionStyle'), plant: pick('PlantCountry'), maker: pick('Manufacturer'),
        };
      })
      .catch(function () { clearTimeout(t); return null; });
  }

  /* Base propia de bastidores (DGT): trozos JSON por inicio del VIN, que se descargan solo cuando hacen falta */
  var dbCache = {};
  function dbKey(vin) {
    if (!DB || !DB.keys) return null;
    for (var l = 4; l >= 1; l--) if (DB.keys.indexOf(vin.slice(0, l)) >= 0) return vin.slice(0, l);
    return null;
  }
  function lookupDb(vin, year, genYears) {
    var key = dbKey(vin);
    if (!key || !window.fetch) return Promise.resolve(null);
    if (!dbCache[key]) {
      dbCache[key] = fetch((settings.assetBase || '') + 'ta-vindb-' + DB.v + '-' + key + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return dbCache[key].then(function (c) {
      var rows = c && c.p[vin.slice(0, 8)];
      if (!rows) return null;
      var list = rows.map(function (r) { return { make: c.m[r[0]], model: c.n[r[1]], cc: r[2], kw: r[3], fuel: r[4], n: r[5], from: r[6], to: r[7] }; });
      // Acota los años a los de la generación (los datos de matriculación tienen fechas atípicas)
      if (genYears && genYears[0] < 9999) {
        list.forEach(function (v) {
          if (v.from) v.from = Math.max(v.from, genYears[0]);
          if (v.to && genYears[1]) v.to = Math.min(v.to, genYears[1]);
          if (v.from && v.to && v.from > v.to) { v.from = genYears[0]; v.to = genYears[1]; }
        });
      }
      if (year) {
        var byYear = list.filter(function (v) { return !v.from || (year >= v.from - 1 && year <= v.to + 1); });
        if (byYear.length) list = byYear;
      }
      return list;
    });
  }
  function engineLabel(v) {
    var parts = [];
    if (v.cc) parts.push((Math.round(v.cc / 100) / 10).toFixed(1).replace('.', ',') + ' l');
    if (v.kw) parts.push(v.kw + ' kW (' + Math.round(v.kw * 1.35962) + ' ' + T('hp') + ')');
    if (fuelName(v.fuel)) parts.push(fuelName(v.fuel));
    return parts.join(' · ');
  }
  function yearsLabel(v) { return v.from ? (v.from === v.to ? String(v.from) : v.from + '–' + v.to) : ''; }

  /* ---------- catálogo de la tienda (marcas/modelos con productos) ---------- */
  var catalog = null;
  function getCatalog() {
    if (catalog) return catalog;
    var el = document.querySelector('[data-ta-vehicles]');
    try { catalog = el ? JSON.parse(el.textContent) : null; } catch (e) { catalog = null; }
    return catalog;
  }
  var MAKE_ALIAS = { mercedes: 'mercedes-benz', 'mercedes benz': 'mercedes-benz', vw: 'volkswagen', 'land-rover': 'land rover', 'rolls royce': 'rolls-royce', 'alfa-romeo': 'alfa romeo', 'ssang yong': 'ssangyong' };
  function findMake(name) {
    var c = getCatalog();
    if (!c || !name) return null;
    var n = norm(name).trim();
    n = MAKE_ALIAS[n] || n;
    for (var i = 0; i < c.makes.length; i++) if (norm(c.makes[i].n) === n) return c.makes[i];
    return null;
  }
  function findModel(make, name) {
    if (!make || !name) return null;
    var n = norm(name);
    for (var i = 0; i < make.m.length; i++) if (norm(make.m[i][0]) === n) return make.m[i];
    return null;
  }
  /* Modelo del catálogo para un nombre de otra fuente (matrícula): «CLASE E»/«E 220 CDI» → Clase E, «520D» → Serie 5… */
  function matchModel(make, raw) {
    if (!make || !raw) return null;
    var exact = findModel(make, raw);
    if (exact) return exact;
    var f = flat(raw);
    var byFlat = make.m.filter(function (mo) { return flat(mo[0]) === f; })[0];
    if (byFlat) return byFlat;
    var n = norm(raw).replace(/[-/]/g, ' ').replace(/\s+/g, ' ').trim();
    var mk = flat(make.n);
    var guess = null;
    if (mk === 'mercedesbenz') {
      var c = n.match(/^(?:clase |classe |klasse )?(cla|cls|clk|gla|glb|glc|gle|glk|gls|gl|ml|slk|sl|[abcegrsv])(?=\s|\d|$)/);
      if (c) guess = c[1] === 'gl' || c[1] === 'gls' ? 'GL / GLS' : c[1] === 'v' ? 'Vito / Viano / Clase V' : c[1].length === 1 ? 'Clase ' + c[1].toUpperCase() : c[1].toUpperCase();
    } else if (mk === 'bmw') {
      var x = n.match(/^(x[1-7]|z[34]|i[3-8]|ix\d?)\b/);
      var s = n.match(/^(?:serie |series )?([1-8])(?:\d{2}|\s|$)/);
      guess = x ? x[1].toUpperCase() : s ? 'Serie ' + s[1] : null;
    }
    if (guess) {
      var g = findModel(make, guess);
      if (g) return g;
    }
    // El nombre más largo del catálogo con el que empieza (o que empieza por) el de la matrícula
    var best = null;
    make.m.forEach(function (mo) {
      var m = flat(mo[0]);
      if (m.length >= 2 && (f.indexOf(m) === 0 || m.indexOf(f) === 0) && (!best || m.length > flat(best[0]).length)) best = mo;
    });
    return best;
  }
  /* Serie de Mercedes-Benz en las posiciones 4-6 del VIN europeo (WDD211… = serie 211 → W211/S211) */
  var MB_WMI = /^(WDB|WDC|WDD|WDF|W1K|W1N|W1V|W1W)/;
  function mbSeries(vin) {
    var s = MB_WMI.test(vin || '') ? vin.slice(3, 6) : '';
    return /^\d{3}$/.test(s) ? Number(s) : null;
  }
  function codeHasSeries(code, series) {
    var c = String(code);
    var r = c.match(/(\d{3})\s*-\s*(\d{3})/);
    if (r) return series >= Number(r[1]) && series <= Number(r[2]);
    var n = c.match(/\d{3}/);
    return !!n && Number(n[0]) === series;
  }
  /* Generaciones del modelo con piezas (mo[4] = [código, handle, nº, desde, hasta, categorías]):
     por el código de chasis decodificado y, si no, por el año o el rango de años */
  function pickGens(mo, d, range) {
    var gens = (mo && mo[4]) || [];
    if (!gens.length) return [];
    var chassis = String(d.chassis || '').toUpperCase();
    var overlaps = function (g) {
      if (!range || !g[3]) return true;
      var a = range[0], b = range[1] || range[0];
      var common = Math.min(b, g[4] || 9999) - Math.max(a, g[3]);
      // Un año concreto: dentro del periodo. Un rango de años: al menos un año completo en común
      return a === b ? common >= 0 : common > 0;
    };
    // Mercedes: la serie del VIN manda. Si no tenemos piezas de esa serie (W124, C238…), no se adivina por años
    var series = mbSeries(d.vin);
    if (series && gens.some(function (g) { return /\d{3}/.test(String(g[0])); })) {
      var bySeries = gens.filter(function (g) { return codeHasSeries(g[0], series); });
      var inYears = bySeries.filter(overlaps);
      return inYears.length ? inYears : bySeries;
    }
    var byCode = gens.filter(function (g) {
      var code = String(g[0]).toUpperCase().replace(/[^A-Z0-9]/g, '');
      return code && new RegExp('(^|[^A-Z0-9])' + code + '([^A-Z0-9]|$)').test(chassis);
    });
    if (byCode.length) {
      var narrowed = byCode.filter(overlaps);
      return narrowed.length ? narrowed : byCode;
    }
    // Solo por años: únicamente si encaja una generación (E61/F07/F11 conviven en los mismos años) y, con un
    // rango de años, si al menos el 60 % del rango cae dentro de ella
    var mostlyInside = function (g) {
      if (!range || !g[3]) return false;
      var a = range[0], b = range[1] || range[0];
      if (a === b) return a >= g[3] && a <= (g[4] || 9999);
      var common = Math.min(b, g[4] || 9999) - Math.max(a, g[3]);
      return common > 0 && common / (b - a) >= 0.6;
    };
    var byYear = range ? gens.filter(mostlyInside) : [];
    return byYear.length === 1 ? byYear : [];
  }

  /* ---------- "Mi vehículo" ---------- */
  function vehicleLabel(v) {
    return [v.make, v.model, v.gen ? v.gen : (v.chassis ? '(' + v.chassis + ')' : ''), v.year || ''].filter(Boolean).join(' ');
  }
  function saveVehicle(v) {
    storage('set', v);
    renderMyVehicle();
    document.dispatchEvent(new CustomEvent('ta:vehicle', { detail: v }));
  }
  function collectionsUrl() { return (settings.collectionsUrl || '/collections'); }
  function vehicleUrl(v, typeHandle) {
    var tag = v.genHandle || v.modelHandle || v.makeHandle;
    return collectionsUrl() + '/' + (typeHandle || 'all') + (tag ? '/' + tag : '');
  }
  function renderMyVehicle() {
    var v = storage('get');
    document.querySelectorAll('[data-ta-myvehicle]').forEach(function (box) {
      if (!v) { box.hidden = true; return; }
      box.hidden = false;
      box.innerHTML =
        '<span class="ta-myvehicle__label">' + esc(T('my_vehicle')) + '</span> <a href="' + esc(vehicleUrl(v)) + '"><strong>' + esc(vehicleLabel(v)) + '</strong></a>' +
        ' <button type="button" class="ta-myvehicle__clear" data-ta-clear-vehicle aria-label="' + esc(T('remove_vehicle')) + '">✕</button>';
    });
    document.querySelectorAll('[data-ta-vehicle-chip]').forEach(function (el) {
      if (!v) { el.hidden = true; return; }
      var base = el.getAttribute('data-collection-url');
      el.hidden = false;
      el.href = base + '/' + (v.genHandle || v.modelHandle || v.makeHandle);
      el.textContent = T('chip_my_vehicle', { name: [v.make, v.model, v.gen].filter(Boolean).join(' ') });
    });
    document.querySelectorAll('[data-ta-fitcheck]').forEach(function (box) {
      if (!v) { box.hidden = true; return; }
      var tags = (box.getAttribute('data-tags') || '').split('|');
      // Generaciones de la pieza: «modelo>generación»
      var gens = (box.getAttribute('data-gens') || '').split('|').filter(Boolean).map(function (x) { return x.split('>'); });
      var name = [v.make, v.model, v.gen].filter(Boolean).join(' ');
      var ok = v.modelHandle ? tags.indexOf(v.modelHandle) >= 0 : tags.indexOf(v.makeHandle) >= 0;
      var makeOnly = !ok && v.modelHandle && tags.indexOf(v.makeHandle) >= 0;
      var modelGens = ok && v.genHandle ? gens.filter(function (x) { return x[0] === v.modelHandle; }) : [];
      var genMismatch = modelGens.length && !modelGens.some(function (x) { return x[1] === v.genHandle; });
      box.hidden = false;
      box.className = 'ta-fitcheck ' + (ok && !genMismatch ? 'is-ok' : 'is-warn');
      box.textContent = genMismatch
        ? T('fit_gen', { model: [v.make, v.model].join(' '), gen: v.gen })
        : ok
          ? T('fit_ok', { name: name })
          : (makeOnly ? T('fit_make_only', { make: v.make, model: v.model }) : T('fit_no', { name: name }));
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ta-clear-vehicle]')) {
      storage('del');
      renderMyVehicle();
    }
  });

  /* ---------- ficha del vehículo identificado (bastidor o matrícula) ---------- */
  function row(label, value) {
    return value ? '<tr><th>' + esc(label) + '</th><td>' + value + '</td></tr>' : '';
  }
  function waLink(text) {
    var n = (settings.whatsapp || '').replace(/\D/g, '');
    if (!n) return '';
    return 'https://wa.me/' + n + '?text=' + encodeURIComponent(text);
  }

  /* d: resultado de decode() o, para matrícula, uno equivalente; plate: datos del servicio de matrículas */
  function renderResult(out, d, vp, db, plate) {
    var c = getCatalog();
    db = db && db.length ? db : null;
    // Marca: la que consta en la DGT para ese inicio de bastidor si es clara (≥ 80 %), porque el código de
    // fabricante del VIN puede ser de la matriz (Dacia con VF1 de Renault, Lexus con JTD de Toyota)
    var dbMake = null;
    if (db) {
      var byMake = {};
      var dbTotal = db.reduce(function (s, v) { byMake[v.make] = (byMake[v.make] || 0) + v.n; return s + v.n; }, 0);
      Object.keys(byMake).forEach(function (k) { if (byMake[k] / dbTotal >= 0.8 && findMake(k)) dbMake = k; });
    }
    var makeName = dbMake || d.make || (db && db[0].make) || (vp && vp.make ? vp.make.charAt(0) + vp.make.slice(1).toLowerCase() : null);
    var make = findMake(makeName);
    var modelNames = d.models.slice();
    if (!modelNames.length && db) {
      db.forEach(function (v) { if (modelNames.indexOf(v.model) < 0 && modelNames.length < 3) modelNames.push(v.model); });
    }
    if (!modelNames.length && vp && vp.model && make) {
      var m = vpicModelToStore(make.n, vp.model);
      if (m) modelNames.push(m);
    }
    var found = make ? modelNames.map(function (n) { return findModel(make, n) || (plate ? matchModel(make, n) : null); }).filter(Boolean).filter(function (x, i, a) { return a.indexOf(x) === i; }) : [];
    var year = d.year || (vp && vp.year) || '';
    // Motorización: única o dominante (≥ 80 % de los vehículos matriculados con ese inicio de bastidor)
    var total = db ? db.reduce(function (s, v) { return s + v.n; }, 0) : 0;
    var engine = db && (db.length === 1 || db[0].n / total >= 0.8) ? db[0] : null;
    var years = db ? [Math.min.apply(null, db.map(function (v) { return v.from || 9999; })), Math.max.apply(null, db.map(function (v) { return v.to || 0; }))] : null;

    var html = '<div class="ta-vin-card">';
    if (plate) {
      html += '<div class="ta-vin-card__head"><span class="ta-badge ta-badge--plate">E</span> <code>' + esc(plate.plate) + '</code></div>';
    } else {
      html += '<div class="ta-vin-card__head"><span class="ta-badge">VIN</span> <code>' + esc(d.vin) + '</code>' + (d.corrected ? ' <small>' + esc(T('corrected')) + '</small>' : '') + '</div>';
    }
    html += '<div class="ta-table-wrap"><table class="ta-vin-table"><tbody>';
    html += row(T('make'), esc(make ? make.n : makeName || T('not_identified')));
    html += row(T('model'), esc(modelNames.join(' / ') || (vp && vp.model) || ''));
    if (plate && plate.version) html += row(T('version'), esc(plate.version));
    html += row(T('chassis'), esc(d.chassis || (vp && vp.series) || ''));
    if (plate && plate.registered) html += row(T('registered'), esc(plate.registered));
    else html += row(T('model_year'), esc(year));
    if (!plate && !year && years && years[0] < 9999) html += row(T('reg_years'), esc(years[0] === years[1] ? years[0] : years[0] + '–' + years[1]));
    if (!plate) html += row(T('version'), esc(vp && vp.trim));
    var vpEngine = vp ? [vp.engine, vp.litres ? vp.litres + ' L' : '', vp.cylinders ? vp.cylinders + ' cil.' : '', vp.fuel].filter(Boolean).join(' · ') : '';
    html += row(T('engine'), esc(vpEngine || (engine ? engineLabel(engine) : (db ? T('engines_possible', { count: db.length }) : ''))));
    html += row(T('drive'), esc(vp && vp.drive));
    html += row(T('body'), esc(vp && vp.body));
    html += row(T('made_in'), esc((vp && vp.plant) || d.country || ''));
    if (!plate) html += row(T('serial'), esc(d.serial));
    if (plate && plate.vin) html += row('VIN', '<code>' + esc(plate.vin) + '</code>');
    html += '</tbody></table></div>';

    if (db && !engine && !vpEngine) {
      var group = 'ta-engine-' + (d.vin || (plate && plate.plate) || 'x');
      html += '<fieldset class="ta-vin-engines"><legend>' + esc(T('choose_engine')) + '</legend>';
      db.forEach(function (v, i) {
        html += '<label class="ta-vin-engine"><input type="radio" name="' + esc(group) + '" value="' + i + '" data-ta-engine> ' +
          '<span><strong>' + esc([v.make, v.model].join(' ')) + '</strong> · ' + esc(engineLabel(v)) + (yearsLabel(v) ? ' · ' + esc(yearsLabel(v)) : '') + '</span></label>';
      });
      html += '</fieldset>';
    }

    var vehicle = { vin: d.vin || (plate && plate.vin) || '', plate: plate ? plate.plate : undefined, make: make ? make.n : makeName, makeHandle: make ? make.h : null, model: null, modelHandle: null, chassis: d.chassis, year: year || (years && years[0] < 9999 ? (years[0] === years[1] ? String(years[0]) : years[0] + '–' + years[1]) : ''), engine: engine ? engineLabel(engine) : (vpEngine || null) };
    if (found.length === 1) {
      vehicle.model = found[0][0];
      vehicle.modelHandle = found[0][1];
    }
    // Generación: por el chasis decodificado o por los años (del VIN, de la matrícula, del motor elegido o de las matriculaciones)
    var range = year ? [Number(year), Number(year)] : (engine && engine.from ? [engine.from, engine.to] : (years && years[0] < 9999 ? years : null));
    var gens = [];
    found.forEach(function (mo) { pickGens(mo, d, range).forEach(function (g) { gens.push({ mo: mo, g: g }); }); });
    if (gens.length === 1) {
      vehicle.model = gens[0].mo[0];
      vehicle.modelHandle = gens[0].mo[1];
      vehicle.gen = gens[0].g[0];
      vehicle.genHandle = gens[0].g[1];
    }

    if (make && found.length) {
      html += '<div class="ta-vin-card__parts"><p><strong>' + esc(T('have_parts')) + '</strong></p><div class="ta-actions">';
      gens.forEach(function (x) {
        var yrs = x.g[3] ? ' (' + x.g[3] + '–' + x.g[4] + ')' : '';
        html += '<a class="ta-btn" href="' + esc(collectionsUrl() + '/all/' + x.g[1]) + '" data-ta-pick="' + esc(x.mo[0]) + '" data-ta-gen="' + esc(x.g[0]) + '">' + esc(T('view_parts_for', { count: x.g[2], name: make.n + ' ' + x.mo[0] + ' ' + x.g[0] + yrs })) + '</a>';
      });
      found.forEach(function (mo) {
        html += '<a class="' + (gens.length ? 'ta-link' : 'ta-btn') + '" href="' + esc(collectionsUrl() + '/all/' + mo[1]) + '" data-ta-pick="' + esc(mo[0]) + '">' + esc(gens.length ? T('all_gens_of', { name: make.n + ' ' + mo[0], count: mo[2] }) : T('view_parts_for', { count: mo[2], name: make.n + ' ' + mo[0] })) + '</a>';
      });
      html += '</div>';
      var types = {};
      var single = gens.length === 1 ? gens[0].g : null;
      (single ? [single[5]] : found.map(function (mo) { return mo[3]; })).forEach(function (list) { (list || []).forEach(function (t) { types[t] = 1; }); });
      var typeLinks = !c ? [] : Object.keys(types).map(function (t) {
        var ty = c.types[t];
        return '<a class="ta-chip" href="' + esc(collectionsUrl() + '/' + ty.h + '/' + (single ? single[1] : found[0][1])) + '">' + esc(ty.n) + '</a>';
      });
      if (typeLinks.length) html += '<div class="ta-chips" style="margin-top:12px">' + typeLinks.join('') + '</div>';
      html += '</div>';
    } else if (make) {
      html += '<div class="ta-vin-card__parts"><p>' + esc(T('make_identified', { make: make.n })) + '</p>';
      html += '<div class="ta-chips">' + make.m.map(function (mo) {
        return '<a class="ta-chip" href="' + esc(collectionsUrl() + '/all/' + mo[1]) + '" data-ta-pick="' + esc(mo[0]) + '">' + esc(mo[0]) + ' (' + mo[2] + ')</a>';
      }).join('') + '</div>';
      html += '<p style="margin-top:12px"><a class="ta-link" href="' + esc(collectionsUrl() + '/all/' + make.h) + '">' + esc(T('all_parts_of', { make: make.n, count: make.c })) + '</a></p></div>';
    } else {
      html += '<div class="ta-vin-card__parts"><p>' + esc(T('no_parts')) + '</p></div>';
    }

    var extra = [vehicle.make, vehicle.model, vehicle.gen].filter(Boolean).join(' ');
    var wa = waLink((plate ? T('wa_plate', { plate: plate.plate }) : T('wa_vin', { vin: d.vin })) + (extra ? ' · ' + extra : ''));
    html += '<div class="ta-vin-card__foot">';
    if (wa) html += '<a class="ta-btn ta-btn--dark" href="' + esc(wa) + '" target="_blank" rel="noopener">' + esc(T('confirm_whatsapp')) + '</a>';
    html += '<p class="ta-finder__note">' + esc(T('disclaimer')) + '</p>';
    if (db && !plate) html += '<p class="ta-finder__note ta-vin-source">' + esc(T('source', { source: DB.source || 'DGT' })) + '</p>';
    html += '</div></div>';
    out.innerHTML = html;
    out.hidden = false;

    if (vehicle.make) saveVehicle(vehicle);
    out.querySelectorAll('[data-ta-engine]').forEach(function (input) {
      input.addEventListener('change', function () {
        var v = db[Number(input.value)];
        var mo = make ? findModel(make, v.model) : null;
        var current = storage('get') || vehicle;
        var gl = mo ? pickGens(mo, d, v.from ? [v.from, v.to] : null) : [];
        saveVehicle(Object.assign({}, current, { engine: engineLabel(v), year: current.year || yearsLabel(v) }, mo ? { model: mo[0], modelHandle: mo[1] } : {}, gl.length === 1 ? { gen: gl[0][0], genHandle: gl[0][1] } : {}));
      });
    });
    out.querySelectorAll('[data-ta-pick]').forEach(function (a) {
      a.addEventListener('click', function () {
        var mo = findModel(make, a.getAttribute('data-ta-pick'));
        if (!mo) return;
        var code = a.getAttribute('data-ta-gen');
        var g = code ? (mo[4] || []).filter(function (x) { return x[0] === code; })[0] : null;
        saveVehicle(Object.assign({}, vehicle, { model: mo[0], modelHandle: mo[1], gen: g ? g[0] : null, genHandle: g ? g[1] : null }));
      });
    });
    return vehicle;
  }

  /* ---------- herramienta de búsqueda por VIN ---------- */
  function initTool(tool) {
    var form = tool.querySelector('form');
    var input = tool.querySelector('input[name="vin"]');
    var out = tool.querySelector('[data-ta-vin-result]');
    var counter = tool.querySelector('[data-ta-vin-count]');
    input.addEventListener('input', function () {
      var n = cleanVin(input.value).vin.length;
      if (counter) counter.textContent = n + '/17';
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = decode(input.value);
      if (!d.valid) {
        out.hidden = false;
        out.innerHTML = '<p class="ta-form-msg ta-form-msg--error">' + esc(d.errors.join(' ')) + '</p>';
        return;
      }
      out.hidden = false;
      out.innerHTML = '<p class="ta-finder__note">' + esc(T('identifying')) + '</p>';
      Promise.all([fetchVpic(d.vin), lookupDb(d.vin, d.year, d.genYears)]).then(function (r) { renderResult(out, d, r[0], r[1]); });
    });
    var saved = storage('get');
    if (saved && saved.vin && !input.value) input.value = saved.vin;
  }

  /* ---------- identificación por matrícula española ---------- */
  var PLATE_RE = /^(\d{4}[BCDFGHJKLMNPRSTVWXYZ]{3}|[A-Z]{1,2}\d{4}[A-Z]{1,2}|[A-Z]{1,2}\d{5,6})$/;
  var FUEL_CODE = { gasolina: 0, gasoline: 0, petrol: 0, diesel: 1, gasoil: 1, gasoleo: 1, electrico: 2, electric: 2, glp: 6, gnc: 7 };
  function cleanPlate(raw) { return String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function initPlateTool(tool) {
    var form = tool.querySelector('form');
    var input = tool.querySelector('input[name="plate"]');
    var out = tool.querySelector('[data-ta-plate-result]');
    var panel = tool.closest('[role="tabpanel"]') || document;
    var pending = null;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var plate = cleanPlate(input.value);
      out.hidden = false;
      if (!PLATE_RE.test(plate)) {
        out.innerHTML = '<p class="ta-form-msg ta-form-msg--error">' + esc(T('plate_invalid')) + '</p>';
        return;
      }
      if (!settings.plateEndpoint || !window.fetch) return;
      if (pending) pending.abort();
      pending = window.AbortController ? new AbortController() : null;
      out.innerHTML = '<p class="ta-finder__note">' + esc(T('plate_searching')) + '</p>';
      var url = settings.plateEndpoint + (settings.plateEndpoint.indexOf('?') >= 0 ? '&' : '?') + 'plate=' + encodeURIComponent(plate);
      fetch(url, pending ? { signal: pending.signal } : {})
        .then(function (r) { return r.json().catch(function () { return { error: 'upstream' }; }).then(function (j) { return { status: r.status, body: j }; }); })
        .then(function (res) {
          var p = res.body || {};
          if (p.error || res.status >= 400) {
            var msg = p.error === 'invalid' ? 'plate_invalid' : p.error === 'not_found' ? 'plate_not_found' : (p.error === 'limit' || p.error === 'cap') ? 'plate_limit' : 'plate_error';
            out.innerHTML = '<p class="ta-form-msg ta-form-msg--error">' + esc(T(msg)) + '</p>';
            return;
          }
          var info = { plate: plate, version: [p.version, p.variant].filter(Boolean).join(' · '), registered: p.registered || (p.year ? String(p.year) : ''), vin: p.vin && /^[A-HJ-NPR-Z0-9]{17}$/.test(p.vin) ? p.vin : '' };
          // Con el bastidor, la misma identificación exacta que el buscador por VIN
          if (info.vin) {
            var dv = decode(info.vin);
            if (p.year && !dv.year) dv.year = p.year;
            return lookupDb(dv.vin, dv.year, dv.genYears).then(function (db) { fillQuote(renderResult(out, dv, null, db, info)); });
          }
          var d = { vin: '', valid: true, make: p.make || null, country: null, models: p.model ? [p.model] : [], chassis: null, year: p.year || null, serial: '' };
          var cv = Number(p.powerCv) || 0;
          var db = [{ make: p.make, model: p.model, cc: Number(p.engineCc) || 0, kw: cv ? Math.round(cv / 1.35962) : 0, fuel: FUEL_CODE[norm(p.fuel).replace(/[^a-z]/g, '')], n: 1, from: p.year || 0, to: p.year || 0 }];
          fillQuote(renderResult(out, d, null, db, info));
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          out.innerHTML = '<p class="ta-form-msg ta-form-msg--error">' + esc(T('plate_error')) + '</p>';
        });
    });
    // Rellena el formulario de presupuesto de la misma pestaña con la matrícula y el coche identificado
    function fillQuote(vehicle) {
      var plateField = panel.querySelector('[data-ta-quote-plate]');
      var vehicleField = panel.querySelector('[data-ta-quote-vehicle]');
      if (plateField && !plateField.value) plateField.value = cleanPlate(input.value);
      if (vehicleField && vehicle) vehicleField.value = [vehicleLabel(vehicle), vehicle.engine, vehicle.vin].filter(Boolean).join(' · ');
    }
    var saved = storage('get');
    if (saved && saved.plate && !input.value) input.value = saved.plate;
  }

  function init() {
    document.querySelectorAll('[data-ta-vin-tool]').forEach(initTool);
    if (settings.plateEndpoint) document.querySelectorAll('[data-ta-plate-tool]').forEach(initPlateTool);
    renderMyVehicle();
  }
  window.TA_VIN = { decode: decode, cleanVin: cleanVin, lookup: lookupDb, engineLabel: engineLabel, pickGens: pickGens, matchModel: matchModel, findMake: findMake };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
